import React from 'react';
import Tabs from 'src/components/Tabs/Tabs';
import { ITabItem } from 'src/components/Tabs/shared/types';

const tabs: ITabItem<string>[] = [
  {
    key: 'canBeIncluded',
    i18nKey: 'pages.flashProducts.canBeIncluded',
    i18nFallbackText: 'Dahil Olabileceklerim',
    slug: '/flash-products',
  },
  {
    key: 'includedProducts',
    i18nKey: 'pages.flashProducts.tabs.includedProducts',
    i18nFallbackText: 'Dahil Olduklarım',
    slug: '/flash-products/included',
  },
];

export default function FlashProductsTabs() {
  return (
    <>
      <Tabs tabs={tabs} onChange={(tab) => console.log(tab)} />
    </>
  );
}
